import { render, staticRenderFns } from "./CostPricesRulesFilter.vue?vue&type=template&id=6baba6f4"
import script from "./CostPricesRulesFilter.vue?vue&type=script&lang=js"
export * from "./CostPricesRulesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports